<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Operarios</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">Administrativo</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Operarios</li>
                </ol>
              </div>
            </div>
          </div>
          <!-- /.container-fluid -->
        </section>
        <!-- Main content -->
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-12">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal_form_operario_export"
                        v-if="$store.getters.can('argentina.operarios.export')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        data-toggle="modal"
                        data-target="#modal-form-operarios"
                        @click="abrirModal('Crear', null)"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body p-0">
                <table
                  id="users"
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead>
                    <tr>
                      <th>
                        Nombre
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.nombre"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        DNI
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.numero_documento"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Email
                        <input
                          type="email"
                          class="form-control form-control-sm"
                          v-model="filtros.email"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Estado
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="operario in operarios.data" :key="operario.id">
                      <td>{{ operario.nombres }} {{ operario.apellidos }}</td>
                      <td>{{ operario.numero_documento }}</td>
                      <td>{{ operario.email }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="
                            operario.estado == 1
                              ? 'badge-success'
                              : 'badge-danger'
                          "
                        >
                          {{ operario.nEstado }}</span
                        >
                      </td>
                      <td style="width: 50px">
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            data-toggle="modal"
                            data-target="#modal-form-operarios"
                            @click="abrirModal('Editar', operario.id)"
                            v-if="
                              $store.getters.can('argentina.operarios.edit')
                            "
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="operarios.total">
                  <p>
                    Mostrando del <b>{{ operarios.from }}</b> al
                    <b>{{ operarios.to }}</b> de un total:
                    <b>{{ operarios.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="operarios"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="modal-form-operarios">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">{{ modal.title }}</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="nombre">Nombre</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="nombres"
                placeholder="Nombre"
                v-model="form.nombres"
                :class="$v.form.nombres.$invalid ? 'is-invalid' : 'is-valid'"
              />
            </div>
            <div class="form-group">
              <label for="apellidos">Apellidos</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="apellidos"
                placeholder="Apellidos"
                v-model="form.apellidos"
                :class="$v.form.apellidos.$invalid ? 'is-invalid' : 'is-valid'"
              />
            </div>
            <div class="form-group">
              <label for="nombre">DNI</label>
              <input
                type="number"
                class="form-control form-control-sm"
                id="numero_documento"
                placeholder="DNI"
                v-model="form.numero_documento"
                :class="
                  $v.form.numero_documento.$invalid ? 'is-invalid' : 'is-valid'
                "
                @blur="validaOperario()"
              />
            </div>
            <div class="form-group">
              <label for="nombre">Celular</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="celular"
                placeholder="Celular"
                v-model="form.celular_principal"
                :class="
                  $v.form.celular_principal.$invalid ? 'is-invalid' : 'is-valid'
                "
              />
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input
                type="email"
                class="form-control form-control-sm"
                id="email"
                placeholder="Email"
                v-model="form.email"
                :class="$v.form.email.$invalid ? 'is-invalid' : 'is-valid'"
              />
            </div>
            <div class="form-group">
              <label for="estado">Estado</label>
              <select
                id="estado"
                class="form-control form-control-sm"
                v-model="form.estado"
                :class="$v.form.estado.$invalid ? 'is-invalid' : 'is-valid'"
              >
                <option value="">Seleccione...</option>
                <option
                  v-for="estado in listasForms.estados"
                  :key="estado.id"
                  :value="estado.id"
                >
                  {{ estado.descripcion }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form.$invalid"
              @click="save()"
            >
              Guardar
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  required,
  minLength,
  maxLength,
  numeric,
  email,
} from "vuelidate/lib/validators";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";

export default {
  name: "OperarioIndex",
  components: {
    pagination,
    Loading,
  },
  data() {
    return {
      filtros: {
        nombres: null,
        apellidos: null,
        numero_documento: null,
        email: null,
        estado: null,
      },
      operarios: {},
      form: {},
      listasForms: {
        estados: [],
      },
      modal: {
        title: "",
        accion: "",
      },
      cargando: false,
      page: "",
    };
  },
  validations: {
    form: {
      nombres: {
        required,
      },
      apellidos: {
        required,
      },
      numero_documento: {
        required,
        numeric,
        minLength: minLength(6),
        maxLength: maxLength(11),
      },
      celular_principal: {
        required,
        minLength: minLength(6),
      },
      email: {
        required,
        email,
      },
      estado: {
        required,
      },
    },
  },
  methods: {
    getIndex(page = 1) {
      this.page = page;
      this.cargando = true;
      axios
        .get("/api/argentina/operarios?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.operarios = response.data;
          this.cargando = false;
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
          });
          this.cargando = false;
        });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    abrirModal(accion, idOperario) {
      this.getEstados();
      this.modal.accion = accion;
      this.modal.title = accion + " Operario";
      if (accion == "Editar") {
        this.show(idOperario);
      } else {
        this.form = {};
      }
    },

    validaOperario() {
      if (this.accion == "Editar") {
        return;
      }

      let params = {
        numero_documento: this.form.numero_documento,
      };
      axios
        .get("/api/argentina/operarios/lista", {
          params,
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.form.numero_documento = null;
            this.$swal({
              icon: "error",
              title: "El DNI digitado ya se encuentra registrado...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        });
    },

    save() {
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        this.form.pais_id = 3;
        this.form.tipo_documento = 1;
        axios
          .post("/api/argentina/operarios", this.form)
          .then((response) => {
            this.$refs.closeModal.click();
            this.form = {};
            this.getIndex(this.page);
            this.$swal({
              icon: "success",
              title: "Se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vualeva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          });
      }
    },

    show(idOperario) {
      axios
        .get("/api/argentina/operarios/show/" + idOperario)
        .then((response) => {
          this.form = response.data;
        });
    },

    destroy(idOperario) {
      this.$swal({
        title: "Esta seguro de eliminar este Item?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/api/argentina/operarios/" + idOperario)
            .then((response) => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se elimino el item exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
  },
};
</script>

<style>
.pac-container {
  z-index: 1051 !important;
}
</style>
